/* eslint-disable */

import { type FetchResponse, type IHttpApi, type IHttpApiFetchConfig } from '@cian/http-api/shared';

import { type IGetNewbuildingCallbackWidgetResponse, type TGetNewbuildingCallbackWidgetModel } from './types';

export function createGetNewbuildingCallbackWidgetModel(): TGetNewbuildingCallbackWidgetModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-callback-widget-frontend',
    pathApi: '/v1/get-widget/',
    response: {
      '200': {
        contentType: 'json',
      },
    },
  };
}
export interface IGetNewbuildingCallbackWidgetOptions {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
}

export async function fetchGetNewbuildingCallbackWidget({ httpApi, config }: IGetNewbuildingCallbackWidgetOptions) {
  const { response, statusCode } = (await httpApi.fetch(
    createGetNewbuildingCallbackWidgetModel(),
    config,
  )) as FetchResponse<IGetNewbuildingCallbackWidgetResponse>;

  return { response, statusCode };
}
